import { defineStore } from 'pinia'
import { ref } from 'vue'

import { RTCSessionFacade } from '@/entities/webrtc'

interface MutedCallsBySessionId {
  [sessionId: RTCSessionFacade['sessionId']]: boolean
}

export const useCallRingingStore = defineStore('call-ringing', () => {
  const mutedSessions = ref<MutedCallsBySessionId>({})

  const muteBySessionId = (sessionId: RTCSessionFacade['sessionId']): void => {
    mutedSessions.value[sessionId] = true
  }

  const isSessionRingingEnabled = (sessionId: RTCSessionFacade['sessionId']): boolean => {
    if (mutedSessions.value[sessionId]) {
      return !mutedSessions.value[sessionId]
    }
    return true
  }

  const deleteBySessionId = (sessionId: RTCSessionFacade['sessionId']): void => {
    delete mutedSessions.value[sessionId]
  }

  return {
    muteBySessionId,
    isSessionRingingEnabled,
    deleteBySessionId,
  }
})
